import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Dashboard from './pages/Dashboard';
import EmailVerificationPage from './pages/EmailVerificationPage';
import SignInPage from './pages/SignInPage';
import ChooseAccountPage from './pages/ChooseAccountPage';
import ForgotPasswordPage from './pages/ForgotPassword';
import SignUpPage from './pages/SignUpPage';
import LandingPage from './pages/LandingPage';
import VenueSelection from './pages/VenueSelection';
import ParameterChoice from './pages/ParameterChoice';
import TagsMatching from './pages/TagsMatching';
import Distance from './pages/Distance';
import Preferences from './pages/Preferences';
import MatchingFlow from './pages/MatchingFlow';
import BusinessPlan from './pages/BusinessPlan';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailure from './pages/PaymentFailure';
import PaymentUpdateSuccess from './pages/PaymentUpdateSuccess';
import PaymentUpdateFailure from './pages/PaymentUpdateFailure';
import SettingsPage from './pages/SettingsPage';
import AddVenue from './pages/AddVenue';
import SolutionsPage from './pages/SolutionsPage';
import PricingPage from './pages/PricingPage';
import PricingPageCouples from './pages/PricingPageCouples';
import PricingPageBusinesses from './pages/PricingPageBusinesses';
import TrackerPage from './pages/TrackerPage';

import { AuthProvider, VenueContext } from './utils/authprovider';
import ProtectedRoute from './utils/protectedRoutes';
import IconHeart from './assets/icon-heart.png';

import './App.css';

function App() {
  const [activeVenue] = useState(null);

  useEffect(() => {
    document.title = 'BestDay2Marry';
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = IconHeart;
    document.head.appendChild(link);
  }, []);

  return (
    <Router>
      <AuthProvider>
        <VenueContext.Provider value={activeVenue}>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/forgot_password" element={<ForgotPasswordPage />} />
            <Route path="/signup" element={<SignUpPage />} />

            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/pricing/businesses" element={<PricingPageBusinesses />} />
            <Route path="/pricing/couples" element={<PricingPageCouples />} />
            <Route path="/solutions" element={<SolutionsPage />} />

            {/* Protected Routes */}
            <Route element={<ProtectedRoute />}>  
                <Route path="/parameters/:user_id" element={<ParameterChoice />} />
                <Route path="/tags_matching/:user_id" element={<TagsMatching />} />
                <Route path="/distance/:user_id" element={<Distance />} />
                <Route path="/preferences/:user_id" element={<Preferences />} />

                <Route path="/matching_flow/:user_id" element={<MatchingFlow />} />
                <Route path="/business_plan/:user_id" element={<BusinessPlan />} />
                <Route path="/payment_success/:user_id" element={<PaymentSuccess />} />
                <Route path="/payment_failure/:user_id" element={<PaymentFailure />} />
                <Route path="/payment_update_success/:user_id" element={<PaymentUpdateSuccess />} />
                <Route path="/payment_update_failure/:user_id" element={<PaymentUpdateFailure />} />

                <Route path="/venue_selection/:user_id" element={<VenueSelection />} />
                <Route path="/add_venue/:user_id" element={<AddVenue />} />
                <Route path="/user_verification/:user_id" element={<EmailVerificationPage />} />
                <Route path="/choose_account/:user_id" element={<ChooseAccountPage />} />
                <Route path="/tracker/:user_id" element={<TrackerPage />} />
                <Route path="/dashboard/:user_id/*" element={<Dashboard />} />
                <Route path="/settings/:user_id/*" element={<SettingsPage />} />
            </Route>
          </Routes>
        </VenueContext.Provider>
      </AuthProvider>
    </Router>
  );
}

export default App;
